import { useSelector } from 'react-redux';
import { Features, RootState } from '../../shared/store';

export const useFeatures = (): Features =>
  useSelector(({ firestore: { data } }: RootState) => data.features);
